// 引入mitt :注意mitt是一个方法，执行后会返回bus对象
import mitt from "mitt";
const bus = mitt()
export default bus